/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./features.css";
// import content from '../content.json';
import Table from 'react-bootstrap/Table';
import parse from 'html-react-parser';

export default function FeatureSection({ dataJson, dataJsonnew, realtorData }) {

    const imgCDNURL = process.env.REACT_APP_RENOVATION_PROGRAM_CDN_URL;
    const { featureheading, featurelist, featurenote, featuretableheading } = dataJson;
    const { tableHeadings, rows } = dataJsonnew;

    return (
        <>
            <div className="featuresectiondiv">
                <Container>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={8} className='featurecol'>
                            <div className="">
                                <h2 className='featuretitle'>{parse(featureheading)}</h2>
                            </div>
                            <div className="featureli">
                                <ul>
                                    {featurelist.map((item, index) => (
                                        <li key={index}>{parse(item)}</li>
                                    ))}
                                </ul>
                                <p className="">{parse(featurenote)}</p>
                            </div>
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={4} className='featurecol'>
                            <img src={imgCDNURL + "constructionimage.webp"} className='constructionimage' alt="Construction"></img>
                        </Col>
                    </Row>
                </Container>

                <Container fluid className="RenoOffering">
                    <Row className="justify-content-around py-2">
                        <Col sm={12} md={6} lg={5}><h4 className="loanoffering" style={{ backgroundColor: "#083f88" }}>{parse(featuretableheading)}</h4></Col>
                    </Row>
                    <Row className="justifyingcontent py-3">
                        <Col xs={12} sm={12} md={9} lg={12} className="tablecolumnofferings pb-3">
                            <Table bordered responsive="md">
                                <thead>
                                <tr>
                                        {tableHeadings.map((heading, index) => (
                                            <th className="whitetext" key={index} style={heading.style}>{parse(heading.label)}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td>{parse(row.type)}</td>
                                            <td>{parse(row.HomeStyle)}</td>
                                            <td>{parse(row['203kLimited'])}</td>
                                            <td>{parse(row['203kFull'])}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
